import { render, staticRenderFns } from "./Response.vue?vue&type=template&id=332b2c6c&scoped=true&"
import script from "./Response.vue?vue&type=script&lang=ts&"
export * from "./Response.vue?vue&type=script&lang=ts&"
import style0 from "./Response.vue?vue&type=style&index=0&id=332b2c6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332b2c6c",
  null
  
)

export default component.exports